import { AgGridTable } from '@shared/components/ui/AgGridTable';
import type { CourierInvoiceListItem } from '../../../models/types';
import { useCourierInvoicesAgGridColumns } from '../../hooks/useCourierInvoicesAgGridColumns';
import { ColDef } from 'ag-grid-community';
import React from 'react';

interface CourierInvoicesAgGridTableProps {
  rows: CourierInvoiceListItem[];
  basePath: string;
  isFetching?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}

export const CourierInvoicesAgGridTable = React.memo(function CourierInvoicesAgGridTable({
  rows,
  basePath,
  isFetching = false,
  isFetchingNextPage = false,
  fetchNextPage,
  hasNextPage = false,
}: CourierInvoicesAgGridTableProps) {
  const { columnDefs } = useCourierInvoicesAgGridColumns({ basePath });

  return (
    <div
      className={
        isFetching && !isFetchingNextPage ? 'opacity-60 pointer-events-none transition-opacity duration-300' : ''
      }
    >
      <AgGridTable
        data={rows}
        columnDefs={columnDefs as ColDef[]}
        height="calc(100vh - 220px)"
        enableSelection={false}
        isLoading={false}
        rowHeight={52}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        showLoadMoreButton={false}
        infiniteScrollThreshold={200}
        gridOptions={{
          suppressCellFocus: true,
        }}
      />
    </div>
  );
});
